import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Decor_feed.png'


const _withScopeId = n => (_pushScopeId("data-v-62bc92bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "feed__row"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "feed__decor",
  src: _imports_0
}, null, -1))

import { ref, Ref, onBeforeMount, onMounted, onUnmounted } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';
import { CacheService } from '@/services/base/CacheService';
import { WorkItem, WorksSevice } from '@/services/WorksService';
import { OnboardSevice } from '@/services/OnboardService';
import BaseFeedCreation from '@/components/feed/BaseFeedCreation.vue';
import BaseLoader from '@/components/shared/BaseLoader.vue';
import PullRefresh from 'pull-refresh-vue3';

type FeedCache = {
	feed: WorkItem[];
	feedPage: number;
	maxFeedPage: number;
	scroll: number;
};

// Load feed (cache | api)

export default /*#__PURE__*/_defineComponent({
  __name: 'FeedView',
  setup(__props) {

onBeforeMount(() => {
	const feedCache = CacheService.get('feed') as undefined | FeedCache;

	if (feedCache !== undefined) {
		// Load data
		feed.value = feedCache.feed;
		feedPage.value = feedCache.feedPage;
		maxFeedPage.value = feedCache.maxFeedPage;
		cachedScroll.value = feedCache.scroll;
	} else {
		populateFeed();
	}
});

// Save feed (cache)
onBeforeRouteLeave(() => {
	CacheService.set('feed', {
		feed: feed.value,
		feedPage: feedPage.value,
		maxFeedPage: maxFeedPage.value,
		scroll: observedElement.value?.scrollTop
	} as FeedCache);
});

const feed: Ref<WorkItem[]> = ref([]);
const feedPage: Ref<number> = ref(1);
const maxFeedPage: Ref<number> = ref(-1);
const populating: Ref<boolean> = ref(false);
async function populateFeed() {
	if (maxFeedPage.value !== -1 && maxFeedPage.value === feedPage.value)
		return;

	// Show loader at bottom of feed
	if (feedPage.value !== 1) {
		populating.value = true;
	}

	const newFeed = await WorksSevice.getFeed(feedPage.value);
	feed.value = [...feed.value, ...newFeed.items];
	feedPage.value++;
	populating.value = false;

	if (maxFeedPage.value === -1) maxFeedPage.value = newFeed.pages;
}

const observedElement: Ref<HTMLElement | null> = ref(null);
const cachedScroll: Ref<number | null> = ref(null);
onMounted(() => {
	if (!observedElement.value) return;

	// Scroll to value from cache
	if (cachedScroll.value !== null) {
		observedElement.value.scroll({ top: cachedScroll.value });
	}

	observedElement.value.addEventListener('scroll', onScroll);
});
onUnmounted(() =>
	observedElement.value?.removeEventListener('scroll', onScroll)
);

const reachedLoad: Ref<boolean> = ref(false);
function onScroll() {
	if (!observedElement.value) return;

	const maxScroll =
		observedElement.value.scrollHeight -
		observedElement.value.offsetHeight -
		220; // 220px before end of scroll

	if (observedElement.value.scrollTop >= maxScroll && !reachedLoad.value) {
		reachedLoad.value = true;
		populateFeed().then(() => (reachedLoad.value = false));
	}
}

// Feed loading
const feedLoading: Ref<boolean> = ref(false);
function onRefresh() {
	feedPage.value = 1;
	maxFeedPage.value = -1;
	feed.value = [];
	cachedScroll.value = null;

	populateFeed().then(() => {
		feedLoading.value = false;
	});
}

// Onboard: tabs
const showOnboard: Ref<boolean> = ref(false);
onBeforeMount(() => {
	const { onboardTabsState } = OnboardSevice;
	showOnboard.value = onboardTabsState?.finished === false;
});
/*function onFinishOnboard() {
	OnboardSevice.onboardTabsState = { finished: true };
	showOnboard.value = false;
}*/

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "view feed",
    ref_key: "observedElement",
    ref: observedElement
  }, [
    _createVNode(_unref(PullRefresh), {
      "pulling-text": "Потяни вниз",
      "loosing-text": "Потяни вниз",
      "loading-text": "Загружаем...",
      "success-text": "Загрузили!",
      modelValue: feedLoading.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((feedLoading).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        (feed.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feed.value, (work) => {
                return (_openBlock(), _createBlock(BaseFeedCreation, {
                  key: work.id,
                  id: work.id,
                  author: {
						user_id: work.owner_id,
						avatar: work.user_avatar,
						nickname: work.user_nickname
					},
                  image: work.image_url,
                  text: work.description,
                  preview: work.preview,
                  format: "feed"
                }, null, 8, ["id", "author", "image", "text", "preview"]))
              }), 128)),
              (populating.value)
                ? (_openBlock(), _createBlock(BaseLoader, {
                    key: 0,
                    size: "md"
                  }))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock(BaseLoader, {
              key: 1,
              size: "md"
            }))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_2
  ], 512))
}
}

})